import Room from './Room';

function MainArea() {
  return <Room />;
}

export default MainArea;
